module.exports = __webpack_public_path__ + "static/media/logo_as.c5aa97ae.png";